import { Link } from 'react-router-dom';

const footerNavColumns = [
  {
    title: '热门分类',
    links: [
      { label: '网红塌房', path: '/category/wanghong-tafang' },
      { label: '反差视频', path: '/category/fansha-shipin' },
      { label: '八卦内幕', path: '/category/bagua-neimu' },
      { label: '私生活', path: '/category/geren-shenghuo' },
    ],
  },
  {
    title: '快速链接',
    links: [
      { label: '平台风波', path: '/category/pingtai-fengbo' },
      { label: '粉丝争执', path: '/category/fensi-zhengzhi' },
      { label: '关于我们', path: '/about' },
      { label: 'APP下载', path: '/about' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系方式', path: '/about' },
      { label: '商务合作', path: '/about' },
      { label: '隐私政策', path: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-950 border-t border-background-200/40">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-14">
        <div className="flex flex-col lg:flex-row gap-10 mb-12">
          <div className="lg:w-1/3">
            <Link to="/" className="font-heading text-xl font-black tracking-wider text-foreground-950">
              每日大赛<span className="text-primary-500">黑料</span>
            </Link>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed max-w-sm">
              每日大赛黑料网 —— 网红大瓜实时追踪，黑料每日更新，吃瓜爆料第一手。致力于为广大网友提供最新、最全、最真实的网红娱乐圈爆料资讯。
            </p>
          </div>

          <div className="lg:w-2/3 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {footerNavColumns.map((col) => (
              <div key={col.title}>
                <h4 className="text-sm font-heading font-bold text-foreground-950 mb-4">
                  <Link to={col.links[0]?.path || '/'} className="hover:text-primary-500 transition-colors">
                    {col.title}
                  </Link>
                </h4>
                <ul className="flex flex-col gap-2.5">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors duration-200 whitespace-nowrap"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 pt-8 border-t border-background-200/30">
          <div className="flex-shrink-0 w-32 h-20 rounded-lg overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Breaking%20news%20studio%20scene%20with%20dramatic%20crimson%20lighting%2C%20multiple%20screens%20showing%20news%20headlines%2C%20dark%20atmospheric%20newsroom%2C%20editorial%20photography%20style%2C%20cinematic%20mood&width=320&height=200&seq=footer-news-01&orientation=landscape"
              alt="每日大赛黑料网新闻中心"
              className="w-full h-full object-cover rounded-lg"
            />
          </div>
          <div className="flex flex-col gap-1">
            <p className="text-lg font-heading font-black text-foreground-950 tracking-wide">每日大赛黑料</p>
            <p className="text-base font-heading font-black text-foreground-700 tracking-wider">网红大瓜·实时追踪</p>
            <p className="text-sm font-heading font-medium text-secondary-500 tracking-[0.3em]">吃瓜爆料第一手</p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mt-10 pt-6 border-t border-background-200/30">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 每日大赛黑料网 版权所有 | 本站内容仅供娱乐参考
          </p>
          <div className="flex items-center gap-5">
            <a
              href="https://weibo.com"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-foreground-500 hover:text-primary-500 transition-colors duration-200 text-xs underline underline-offset-4"
            >
              微博
            </a>
            <a
              href="https://weixin.qq.com"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-foreground-500 hover:text-primary-500 transition-colors duration-200 text-xs underline underline-offset-4"
            >
              微信
            </a>
            <a
              href="https://www.douyin.com"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-foreground-500 hover:text-primary-500 transition-colors duration-200 text-xs underline underline-offset-4"
            >
              抖音
            </a>
            <a
              href="https://www.xiaohongshu.com"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-foreground-500 hover:text-primary-500 transition-colors duration-200 text-xs underline underline-offset-4"
            >
              小红书
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}